import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { FilterBar2, FilterBar2ListItem, FilterBar2Value } from '@bringg/react-components';

import { filterBar2Translations } from 'bringg-web/features/filter-bar/filter-bar';
import { FilterBarListItemKeys, FiltersObject, InitialFilterBarObject } from './types';
import { monitoringFiltersProvider } from './utils/monitoring-filter-provider';

import styles from './monitoring-filter-bar.module.scss';

export interface FieldsInitialValues {
	selectedUsers?: FilterBar2Value[];
	selectedRuns?: FilterBar2Value[];
}

interface Props {
	onChange: (filterObject: FiltersObject) => void;
	filterBarFilters: FilterBar2ListItem[];
	initialMappedValues: InitialFilterBarObject;
	initialAdditional: FilterBarListItemKeys[];
}

const MonitoringFilterBar = ({ onChange, filterBarFilters, initialMappedValues, initialAdditional }: Props) => {
	const { t } = useTranslation();

	const filterBarTranslations = useMemo(() => filterBar2Translations(t), [t]);

	return (
		<FilterBar2
			className={styles.monitoringFilter}
			onFilter={filterObject => {
				onChange(monitoringFiltersProvider.mapValuesFromFilterBar(filterObject));
			}}
			list={filterBarFilters}
			initialValues={initialMappedValues}
			initialAdditional={initialAdditional}
			translations={filterBarTranslations}
			applyFilterImmediately
		/>
	);
};

export default observer(MonitoringFilterBar);
